import { render, staticRenderFns } from "./student_search_box.vue?vue&type=template&id=78074328&scoped=true"
import script from "./student_search_box.vue?vue&type=script&lang=js"
export * from "./student_search_box.vue?vue&type=script&lang=js"
import style0 from "./student_search_box.vue?vue&type=style&index=0&id=78074328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78074328",
  null
  
)

export default component.exports